module.exports = __webpack_public_path__ + "img/icon-user.abee0bf3.svg";